import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { StyledEngineProvider, ThemeProvider, CssBaseline } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import mixpanel from 'mixpanel-browser'

import { Loader } from 'shared'

import { theme } from 'mui-config'
import ModalProvider from 'utils/providers/ModalProvider'
import AuthProvider from 'utils/providers/AuthProvider'
import AxiosInterceptors from 'utils/AxiosInterceptors'
import AnalyticsProvider, {
  MIXPANEL_KEY,
} from 'utils/providers/AnalyticsProvider'

import App from './App'

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: 1000 * 60,
    },
  },
})
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (MIXPANEL_KEY) {
  const myWindow = window as unknown as {
    Cookiebot: { consent: { statistics: unknown } }
  }
  if (myWindow?.Cookiebot?.consent?.statistics) {
    mixpanel.init(MIXPANEL_KEY)
  } else {
    console.log(
      'Hue: Statistics consent would be needed to initialize analytics'
    )
  }
} else {
  console.log("Hue: analytics token doesn't exist")
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <ModalProvider>
        <AuthProvider>
          <AnalyticsProvider>
            <AxiosInterceptors>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Suspense fallback={<Loader isOpen />}>
                      <CssBaseline />
                      <App />
                    </Suspense>
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </AxiosInterceptors>
          </AnalyticsProvider>
        </AuthProvider>
      </ModalProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
